import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
import { Dialog } from '../components/UI/Dialog';
export const WaitingRoom = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formStep, setFormStep] = useState<'form' | 'whatsapp'>('form');
  const handleJoinWhatsApp = () => {
    window.open('https://chat.whatsapp.com/CbJbXQ03HoOKzBUpMeni9g', '_blank');
  };
  const handleFormComplete = () => {
    setFormStep('whatsapp');
  };
  const handleCloseDialog = () => {
    setIsFormOpen(false);
    setFormStep('form'); // Reset to form step when dialog is closed
  };
  return <div className="pt-20 bg-white" data-id="element-2976">
      <section className="relative py-16 border-b border-gray-200" data-id="element-2977">
        <div className="absolute inset-0 z-0" data-id="element-2978">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/veE5AXEU4CEztbBqZpUQcx/coverrs.png" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-2979" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-2980"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-2981">
          <div className="max-w-3xl mx-auto text-center" data-id="element-2982">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-2983">
              The Waiting Room
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-2984">
              Your first step into The Networking Salon community
            </p>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-2985">
        <div className="container mx-auto px-4" data-id="element-2986">
          <div className="max-w-3xl mx-auto" data-id="element-2987">
            <div className="bg-white p-6 rounded-lg border-2 border-gray-300 mb-8" data-id="element-2988">
              <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-2989">
                🌿 The Networking Salon — The Waiting Room
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-2990">Welcome to The Waiting Room!</p>
              <p className="text-gray-700 mb-4" data-id="element-2991">
                We're excited to have you here — this is your first step into
                The Networking Salon community. Think of this as the lounge
                before the salon: a warm, open space where curiosity meets
                connection.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-2992">
                The Waiting Room is where you get to experience the heartbeat of
                our ecosystem — a community that values genuine relationships,
                thoughtful collaboration, and opportunities that help you grow.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-2993">
                Here, you can connect with other professionals and creatives,
                share relevant opportunities, and get a taste of what it means
                to be part of a high-trust network of culture shapers.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-2994">
                When you're ready, you can choose to step deeper into the main
                community — where you'll access masterclasses, curated
                masterminds, and mentorship from business leaders and creators.
                But for now, this is your launchpad.
              </p>
              <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-2995">
                💬 How to Engage in The Waiting Room
              </h3>
              <div className="space-y-4 mb-8" data-id="element-2996">
                <div className="flex items-start" data-id="element-2997">
                  <span className="mr-2" data-id="element-2998">🌟</span>
                  <p className="text-gray-700" data-id="element-2999">
                    <strong data-id="element-3000">Share Opportunities</strong> If you come across a
                    job, grant, training, or collaboration that could help
                    others — share it here! The Waiting Room thrives on
                    generosity and connection.
                  </p>
                </div>
                <div className="flex items-start" data-id="element-3001">
                  <span className="mr-2" data-id="element-3002">📣</span>
                  <p className="text-gray-700" data-id="element-3003">
                    <strong data-id="element-3004">Promote with Purpose</strong> You can post your own
                    announcements, events, or ads — just make sure they add
                    value to the community. All promotional content will be
                    reviewed by the admin before it goes live.
                  </p>
                </div>
                <div className="flex items-start" data-id="element-3005">
                  <span className="mr-2" data-id="element-3006">💡</span>
                  <p className="text-gray-700" data-id="element-3007">
                    <strong data-id="element-3008">Start Conversations</strong> Ask thoughtful
                    questions, share insights, and engage in discussions that
                    spark ideas. The best connections begin with authentic
                    dialogue.
                  </p>
                </div>
                <div className="flex items-start" data-id="element-3009">
                  <span className="mr-2" data-id="element-3010">🤝</span>
                  <p className="text-gray-700" data-id="element-3011">
                    <strong data-id="element-3012">Network Intentionally</strong> Introduce yourself,
                    tell us what you're working on, and connect with others who
                    share your vision. The Waiting Room is full of people
                    building, learning, and creating just like you.
                  </p>
                </div>
                <div className="flex items-start" data-id="element-3013">
                  <span className="mr-2" data-id="element-3014">🌱</span>
                  <p className="text-gray-700" data-id="element-3015">
                    <strong data-id="element-3016">Stay Curious</strong> Use this space to explore —
                    watch how people connect, notice the kinds of conversations
                    happening, and learn how The Networking Salon cultivates
                    trust and collaboration.
                  </p>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-3017">
                🌍 Why The Waiting Room Matters
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-3018">
                The Waiting Room isn't just a holding space — it's a preview of
                what's possible when you engage intentionally. It's where:
              </p>
              <ul className="list-disc list-inside text-gray-700 mb-6 pl-4" data-id="element-3019">
                <li data-id="element-3020">New voices meet opportunity</li>
                <li data-id="element-3021">Ideas start taking shape</li>
                <li data-id="element-3022">Collaborations begin</li>
                <li data-id="element-3023">And relationships grow before they're formalized</li>
              </ul>
              <p className="text-gray-700 mb-6" data-id="element-3024">
                By being here, you're already part of something meaningful — a
                movement built on connection, creativity, and contribution.
              </p>
              <p className="text-gray-700 mb-6 font-medium" data-id="element-3025">
                Welcome to the start of your journey. The conversation begins
                here. The opportunity begins with you.
              </p>
              <div className="bg-gray-100 p-4 rounded-lg border border-gray-300 text-center" data-id="element-3026">
                <p className="text-gray-700 mb-4 font-medium" data-id="element-3027">
                  Ready to join The Waiting Room?
                </p>
                <p className="text-gray-700 mb-6" data-id="element-3028">
                  Complete the registration form and then join our WhatsApp
                  group to access the community.
                </p>
                <Button onClick={() => setIsFormOpen(true)} data-id="element-3029">
                  Join The Waiting Room
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Form Dialog */}
      <Dialog isOpen={isFormOpen} onClose={handleCloseDialog} title={formStep === 'form' ? 'Join The Waiting Room' : 'Complete Your Registration'} size="lg" data-id="element-3030">
        {formStep === 'form' ? <div className="p-4" data-id="element-3031">
            <div className="w-full mb-6" data-id="element-3032">
              <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdr_5jvYO4hJncEC0hjHQweFJSh8FFpzrBhsjQvCQemuZT7MA/viewform?embedded=true" width="100%" height="600" frameBorder="0" marginHeight={0} marginWidth={0} data-id="element-3033">
                Loading…
              </iframe>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg border border-gray-300 text-center" data-id="element-3034">
              <p className="text-gray-700 mb-4" data-id="element-3035">
                <strong data-id="element-3036">Step 1 of 2:</strong> Complete the form above, then
                click the button below to continue.
              </p>
              <Button onClick={handleFormComplete} className="mb-2" data-id="element-3037">
                I've Completed the Form
              </Button>
            </div>
          </div> : <div className="p-4" data-id="element-3038">
            <div className="bg-gray-100 p-6 rounded-lg border-2 border-gray-300 text-center" data-id="element-3039">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3040">
                Thank you for joining The Waiting Room!
              </h3>
              <p className="text-gray-700 mb-6" data-id="element-3041">
                <strong data-id="element-3042">Step 2 of 2:</strong> Click the button below to join our
                WhatsApp group and complete your registration.
              </p>
              <Button onClick={handleJoinWhatsApp} className="mb-4" data-id="element-3043">
                Join WhatsApp Group
              </Button>
              <p className="text-sm text-gray-500" data-id="element-3044">
                If the button doesn't work, copy this link:
                <br data-id="element-3045" />
                <span className="font-medium break-all" data-id="element-3046">
                  https://chat.whatsapp.com/CbJbXQ03HoOKzBUpMeni9g
                </span>
              </p>
            </div>
          </div>}
      </Dialog>
    </div>;
};